import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  childRemoveListSelector,
  isEnableLoadingChildRemoveSelector,
} from '../selector';
import { getChildRemoveList, refreshChildRemoveList } from '../thunk';

import type { TableBaseColumnType, TableBaseRowType } from '@/components/TableBase/Body';

import AdditionalLoading from '@/components/AdditionalLoading';
import TableBase from '@/components/TableBase';
import { toStringDateTimeDisplay } from '@/utils/date';

const Notification: React.FC = () => {
  const dispatch = useDispatch();
  const childRemoveList = useSelector(childRemoveListSelector);
  const isEnableLoading = useSelector(isEnableLoadingChildRemoveSelector);
  const rows: TableBaseRowType[] = [];
  for (let i = 0; i < childRemoveList.length; i += 1) {
    const {
      childFamilyName,
      childName,
      removeDateTime,
    } = childRemoveList[i].data;
    const dateString = toStringDateTimeDisplay(new Date(removeDateTime));
    rows.push({
      id: i.toString(),
      removeDateTime: dateString,
      name: `${childFamilyName} ${childName}`,
    });
  }
  if (rows.length === 0) {
    rows.push({
      id: '-',
      removeDateTime: '登録されていません',
      name: '-',
    });
  }
  const columns: TableBaseColumnType[] = [
    { id: 'removeDateTime', label: '日時', minWidth: 170 },
    { id: 'name', label: '氏名', minWidth: 100 },
  ];
  return (
    <div>
      <TableBase
        rows={rows}
        columns={columns}
        actions={[]}
        refreshAction={() => dispatch(refreshChildRemoveList())}
        isPagination={false}
        isShowFilter={false}
        isShowFooter={false}
      />
      <AdditionalLoading
        isEnableLoading={isEnableLoading}
        onClick={() => dispatch(getChildRemoveList())}
      />
    </div>
  );
};

export default Notification;
